// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApiPutPriceAlertRequest,
  DefaultApi as PriceAlertApi,
  PriceAlertCreateModify,
} from '@eih-netbroker/api-price-alert';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

type CreatePriceAlertRequest = Omit<PriceAlertCreateModify, keyof ResourceHeadersWithToken>;
type UpdatePriceAlertRequest = Omit<DefaultApiPutPriceAlertRequest, keyof ResourceHeadersWithToken>;

export class PriceAlertResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'PriceAlertResource';

  private priceAlertApi: PriceAlertApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, basePath, configApi);
    this.priceAlertApi = new PriceAlertApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.priceAlert}`,
      }),
      basePath,
      axiosInstance,
    );
  }

  loadPriceAlerts(headers: ResourceHeadersWithToken) {
    return this.priceAlertApi.getPriceAlerts(headers);
  }

  createPriceAlert(params: CreatePriceAlertRequest, headers: ResourceHeadersWithToken) {
    return this.priceAlertApi.postPriceAlert({ priceAlertCreateModify: params, ...headers });
  }

  updatePriceAlert(params: UpdatePriceAlertRequest, headers: ResourceHeadersWithToken) {
    return this.priceAlertApi.putPriceAlert({ ...params, ...headers });
  }

  deletePriceAlert(priceAlertId: number, headers: ResourceHeadersWithToken) {
    return this.priceAlertApi.deletePriceAlert({ priceAlertId, ...headers });
  }

  getVersion() {
    return this.priceAlertApi.getVersion();
  }
}
